import React from 'react';
import { InputLabel, FormControl, MenuItem, Select } from '@mui/material';

export const PaygroupDropdown = ({
  payrollPayGroups,
  payrollPayGroupId,
  onChange,
}: {
  payrollPayGroups: { id: string; payGroupDisplayName: string }[];
  payrollPayGroupId?: string;
  onChange: (id: string) => void;
}) => (
  <FormControl>
    <InputLabel id="paygroup-dropdown">Pay Group</InputLabel>
    <Select
      labelId="paygroup-dropdown"
      value={payrollPayGroupId}
      label="Pay Group"
      onChange={({ target }) => onChange(target.value)}
      style={{ minWidth: 200 }}
    >
      {payrollPayGroups.map((p) => (
        <MenuItem key={p.id} value={p.id}>
          {p.payGroupDisplayName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
